import { HttpClient, HttpParams } from '@angular/common/http';
import { ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { interval } from 'rxjs';

@Component({
  selector: 'app-nda',
  templateUrl: './nda.component.html',
  styleUrls: ['./nda.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NDAComponent implements OnInit {

  NDAName: string;
  ClientId: string;
  ContractNumber: any;
  Service: string;
  Validfrom: any;
  ValidTo: any;
  CompanyName: string;
  CompanyRole: string;
  CompanyDate: any;
  ClientName: string;
  ClientRole: string;
  ClientDate: any;
  description: string;
  NDAExport = [] as any;
  public searchText: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownservice: boolean = true;
  Addcomp = [] as any;
  Adclient = [] as any;
  Contracts = [];
  contractsid: string;
  contractNum: string;
  onboard = [];
  onboardingid: string;
  customcode: string;
  myFiles: string[] = [];
  isShownimage: boolean = true;
  select = [] as any;
  selects = [] as any;
  doclist: string;
  isShowndoclist: boolean = true;
  imageurl: string;
  surl: string;
  EditedNDA = [] as any;
  EditedNDAId: string;
  Status: boolean = false;
  NDACompany = [] as any;
  NDAClient = [] as any;
  contracts = [];
  contractsId: string;
  contractservice: string;
  cntService: string;
  cservice: string;
  EditedCompanyId: string;
  EditedClientId: string;
  EditedDoc = [] as any;
  EditedDocId: string;
  updatedocid = [] as any;
  vardocid = [] as any;
  varurl = [] as any;
  NDACompanyRemove = [] as any;
  NDAClientRemove = [] as any;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;
  sOldOnboadId:string;

  displayedColumns: string[] = ['sno', 'name', 'services', 'validfrom', 'validto', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  @ViewChild('file')
  myInputVariable: ElementRef;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('NdaRead');
    this.vWrite = localStorage.getItem('NdaWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    this.sOldOnboadId=this.sOnboardingId;
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('', 'Please Select A Customer First!');
    }   

    this.BindNdaGrid();
    this.BindOnboardDDL();
    this.BindContractDDL();
    
    this.BindNDAExport();
    this.Addcomp.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
    this.Adclient.push({ ClientName: "vClientName1", ClientRole: "vClientRole1", ClientDate: "vClientDate1" });

    interval(3000).subscribe(x => {
      this.sOnboardingId = localStorage.getItem('OnboardingId');
      if (this.sOldOnboadId != this.sOnboardingId) {
        this.BindNdaGrid();
        this.BindOnboardDDL();
    this.BindContractDDL();
    
    this.BindNDAExport();
    debugger;
    this.onboardingid =this.sOnboardingId;
      this.sOldOnboadId=this.sOnboardingId;
      }
    });
  }


  public uploadFile = (files) => {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    debugger;
    if (files.length == 0) {
      return;
    }
    for (var i = 0; i < files.length; i++) {
      this.myFiles.push(files[i]);
    }
    debugger;
    //let fileToUpload = <File>files[0];
    const formData = new FormData();
    //formData.append('file', fileToUpload, fileToUpload.name);
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file[]", this.myFiles[i]);
    }

    this.http.post(environment.apiUrl + 'NDA/UploadContent', formData).subscribe(
      (response) => {
        debugger;
        alert(response);
      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Upload Failed, Please Try Again.";
          return false;
        }
        else {
          this.surl = vErrorMsg1;
          var spliturl = vErrorMsg1.split(",");
          for (var i = 0; i < spliturl.length; i++) {
            this.isShownimage = false;
            this.isShowndoclist = false;
            var furl = spliturl[i];
            var cvname = furl.split("/");
            var fname = cvname[7];
            this.selects.push({ filename: fname, fileURL: furl });
            this.imageurl = furl;
            this.isShownSuccess = false;
            this.SuccessMsg = "File Uploaded";
            this.myFiles = [];
            this.myInputVariable.nativeElement.value = "";
          }
        }
      }
    )

  }

  Show(event: any) {
    debugger;
    var cnt1 = this.Contracts;
    let cnt: any = event.target.value;

    for (let i = 0; i < cnt1.length; i++) {
      if (cnt1[i].contractsid == cnt) {
        var NAme = cnt1[i].cservices;
        this.isShownservice = false;
        this.cntService = NAme;
      }
    }
  }

  BindContractDDL() {
    debugger;
    var vcustomcode = this.sOnboardingId;
    this.onboardingid =vcustomcode;
    debugger;
    let params = new HttpParams();
    params = params.append('donboardid', this.onboardingid);
    var value = this.http.get(environment.apiUrl + 'NDA/GetContractDDL', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        //if (data.length != 0) {
        debugger;
        this.Contracts = data;
        this.contractsid = "0";
        this.cservice = "";
        // }
        // else {
        // };
      });
  }

  BindOnboardDDL() {
    var value = this.http.get(environment.apiUrl + 'NDA/GetOnboardDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.onboard = data;
          interval(3000).subscribe(x => {
          var vcustomcode = this.sOnboardingId;
          this.onboardingid =vcustomcode;
          })
          //debugger;          
          //this.onboardingid = "0";
          //this.contractsid = "0";
        }
        else {
        };
      });
  }

  Submitnda() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    var vndaname = this.onboardingid;
    var vclientid = this.contractsid;
    var vcontractnum = this.contractNum;
    var vService = this.cntService;
    var vValidfrom = this.Validfrom;
    var vValidTo = this.ValidTo;
    var vdescription = this.description;


    debugger;
    this.sOldOnboadId=this.sOnboardingId;
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('', 'Please Select A Customer First!');
      return;
    }   
    if (vndaname == undefined || vndaname == "" || vndaname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Customer Code.";
      return false;
    }

    if (vclientid == undefined || vclientid == "" || vclientid == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contract.";
      return false;
    }

    if (vcontractnum == undefined || vcontractnum == "" || vcontractnum == "0") {
      this.contractNum = "1";
    }

    if (vValidfrom == undefined || vValidfrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid From Date.";
      return false;
    }

    if (vValidTo == undefined || vValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid To Date.";
      return false;
    }
    if (vValidfrom > vValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should Greater then Valid From Date.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = ""
    }


    if (this.Addcomp != null) {
      if (this.Addcomp.length != 0) {
        for (var i = this.Addcomp.length - 1; i >= 0; i--) {
          var v1 = this.Addcomp[i].CompanyName;
          var v2 = this.Addcomp[i].CompanyRole;
          var v3 = this.Addcomp[i].CompanyDate;
          debugger;
          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarCompanyName == undefined || vVarCompanyName == "" || vVarCompanyName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Company.";
            return false;
          }

          if (vVarCompanyRole == undefined || vVarCompanyRole == "" || vVarCompanyRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Role.";
            return false;
          }

          if (vVarCompanyDate == undefined || vVarCompanyDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Date.";
            return false;
          }

          if (vValidfrom >= vVarCompanyDate || vValidTo <= vVarCompanyDate) {
            this.isShownError = false;
            this.ErrorMsg = "Company Signed Date should between Valid From and Valid To Date .";
            return false;
          }

          // if(vValidTo < vVarCompanyDate)
          // {
          //   this.isShownError = false;
          //   this.ErrorMsg = "Company Signed Date should be lesser than a Valid to Date .";
          //   return false;
          // }

        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Company Details..";
      return false;
    }
    if (this.Adclient != null) {
      if (this.Adclient.length != 0) {
        for (var i = this.Adclient.length - 1; i >= 0; i--) {
          var v1 = this.Adclient[i].ClientName;
          var v2 = this.Adclient[i].ClientRole;
          var v3 = this.Adclient[i].ClientDate;
          debugger;
          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarClientName == undefined || vVarClientName == "" || vVarClientName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Client.";
            return false;
          }

          if (vVarClientRole == undefined || vVarClientRole == "" || vVarClientRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Role.";
            return false;
          }

          if (vVarClientDate == undefined || vVarClientDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Date.";
            return false;
          }

          if (vValidfrom >= vVarClientDate || vValidTo <= vVarClientDate) {
            this.isShownError = false;
            this.ErrorMsg = "Client Signed Date should between Valid From and Valid To Date .";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Client Details..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dndaname', this.onboardingid);
    params = params.append('dclientid', this.contractsid);
    params = params.append('dContractNumber', this.contractNum);
    params = params.append('dService', this.cntService);
    params = params.append('dValidfrom', this.Validfrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('iOnboardingId', this.sOnboardingId);

    var value = this.http.get(environment.apiUrl + 'NDA/InsertNda', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var NDAID = data;
        for (var i = this.Addcomp.length - 1; i >= 0; i--) {
          var v1 = this.Addcomp[i].CompanyName;
          var v2 = this.Addcomp[i].CompanyRole;
          var v3 = this.Addcomp[i].CompanyDate;

          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params1 = new HttpParams();
          params1 = params1.append('iNDAID', NDAID);
          params1 = params1.append('iCompanyName', vVarCompanyName);
          params1 = params1.append('irole', vVarCompanyRole);
          params1 = params1.append('iDate', vVarCompanyDate);
          var value = this.http.get(environment.apiUrl + 'NDA/InsertNDACompany', { params: params1 }).toPromise().then((data))
        }
        for (var i = this.Adclient.length - 1; i >= 0; i--) {
          debugger;
          var v1 = this.Adclient[i].ClientName;
          var v2 = this.Adclient[i].ClientRole;
          var v3 = this.Adclient[i].ClientDate;

          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params2 = new HttpParams();
          params2 = params2.append('siNDAID', NDAID);
          params2 = params2.append('sCompanyName', vVarClientName);
          params2 = params2.append('srole', vVarClientRole);
          params2 = params2.append('sDate', vVarClientDate);
          var value1 = this.http.get(environment.apiUrl + 'NDA/InsertNDAClient', { params: params2 }).toPromise().then((data))
        }
        var spliturl = this.surl;
        debugger;
        if (spliturl != undefined && spliturl != "") {
          let params3 = new HttpParams();
          params3 = params3.append('sNDAID', NDAID);
          params3 = params3.append('sfurl', spliturl);
          var value2 = this.http.get(environment.apiUrl + 'NDA/InsertNDADoc', { params: params3 }).toPromise().then(
            (data: any) => {
              debugger;
              this.isShownSuccess = false;
              this.SuccessMsg = "NDA Added."
              this.BindNdaGrid();
              this.BindNDAExport();
              var ContractId = data;
              this.NDAName = "";
              //this.onboardingid = "";
              this.ContractNumber = "";
              this.Service = "";
              this.cntService = "";
              this.Validfrom = "";
              this.ValidTo = "";
              this.CompanyName = "";
              this.CompanyRole = "";
              this.CompanyDate = "";
              this.ClientName = "";
              this.ClientRole = "";
              this.ClientDate = "";
              this.description = "";
              this.surl = "";
              this.isShowndoclist = true;
              this.isShownservice = true;
              this.Addcomp = [];
              this.Addcomp.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
              this.Adclient = [];
              this.Adclient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
            }).catch((data: any) => {
              debugger;
              var vDataError = JSON.stringify(data.error.text);
              var vErrorMsg = vDataError.replace('"', '');
              this.isShownSuccess = false;
              this.SuccessMsg = "NDA Added."
              this.BindNdaGrid();
              this.BindNDAExport();
              var ContractId = data;
              this.NDAName = "";
              //this.onboardingid = "";
              this.ContractNumber = "";
              this.Service = "";
              this.cntService = "";
              this.Validfrom = "";
              this.ValidTo = "";
              this.CompanyName = "";
              this.CompanyRole = "";
              this.CompanyDate = "";
              this.ClientName = "";
              this.ClientRole = "";
              this.ClientDate = "";
              this.description = "";
              this.surl = "";
              this.isShowndoclist = true;
              this.isShownservice = true;
              this.Addcomp = [];
              this.Addcomp.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
              this.Adclient = [];
              this.Adclient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
            })
        }
        else {
          this.isShownSuccess = false;
          this.SuccessMsg = "NDA Added."
          this.BindNdaGrid();
          this.BindNDAExport();
          var ContractId = data;
          this.NDAName = "";
          //this.onboardingid = "";
          this.ContractNumber = "";
          this.cntService = "";
          this.Validfrom = "";
          this.ValidTo = "";
          this.CompanyName = "";
          this.CompanyRole = "";
          this.CompanyDate = "";
          this.ClientName = "";
          this.ClientRole = "";
          this.ClientDate = "";
          this.description = "";
          this.surl = "";
          this.isShowndoclist = true;
          this.isShownservice = true;
          this.Addcomp = [];
          this.Addcomp.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
          this.Adclient = [];
          this.Adclient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }

  AddCompany() {
    debugger;
    var vLength = this.Addcomp.length;
    var v1 = "vCompanyName" + (vLength + 1);
    var v2 = "vCompanyRole" + (vLength + 1);
    var v3 = "vCompanyDate" + (vLength + 1);
    this.Addcomp.push({ CompanyName: v1, CompanyRole: v2, CompanyDate: v3, ContractsId: "" });
  }

  AddClient() {
    debugger;
    var vLength = this.Adclient.length;
    var v1 = "vClientName" + (vLength + 1);
    var v2 = "vClientRole" + (vLength + 1);
    var v3 = "vClientDate" + (vLength + 1);
    this.Adclient.push({ ClientName: v1, ClientRole: v2, ClientDate: v3, ContractsId: "" });
  }

  Clearnda() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownUpdateBtn = true;
    this.isShownSaveBtn = false;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.NDAName = "";
    //this.onboardingid = "";
    var vcustomcode = this.sOnboardingId;
    this.onboardingid =vcustomcode;
    this.contractsId = "";
    //this.onboardingid = "0";
    this.contractsid = "0";
    this.ContractNumber = "";
    this.Service = "";
    this.Validfrom = "";
    this.ValidTo = "";
    this.CompanyName = "";
    this.CompanyRole = "";
    this.CompanyDate = "";
    this.ClientName = "";
    this.ClientRole = "";
    this.ClientDate = "";
    this.description = "";
    this.surl = "";
    this.isShowndoclist = true;
    this.isShownservice = true;
    this.Addcomp = [];
    this.Addcomp.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
    this.Adclient = [];
    this.Adclient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
    this.BindContractDDL();
  }

  EditNDA(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownservice = false;
    this.EditedNDA = item;
    debugger;

    var vndaid = this.EditedNDA.ndaid;
    var vcustom = this.EditedNDA.customId;
    var vcontract = this.EditedNDA.contractsid;
    var vservices = this.EditedNDA.services;
    var vvalidfrom = this.EditedNDA.validfrom1;
    var vvalidto = this.EditedNDA.validto1;
    var vdescription = this.EditedNDA.description;
    var vstatus = this.EditedNDA.status;
    debugger;
    this.onboardingid = vcustom;
    //this.contractsid = vcontract;
    //this.Service = vservices;
    this.Validfrom = new Date(new Date(vvalidfrom).setDate(new Date(vvalidfrom).getDate() + 1)).toISOString().split('T')[0];
    this.ValidTo = new Date(new Date(vvalidto).setDate(new Date(vvalidto).getDate() + 1)).toISOString().split('T')[0];
    this.description = vdescription;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }

    this.onboardingid = vcustom;
    debugger;
    let params = new HttpParams();
    params = params.append('donboardid', this.onboardingid);
    var value = this.http.get(environment.apiUrl + 'NDA/GetContractDDL', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        //if (data.length != 0) {
        debugger;
        this.Contracts = data;
        this.contractsid = vcontract;
        this.cntService = vservices;
        // }
        // else {
        // };
      });

    this.EditedNDAId = vndaid;
    var value1 = this.http.get(environment.apiUrl + 'NDA/GetCompanyForEdit?contractID=' + vndaid).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData = data;
          debugger;
          var vcompanyid = vData["0"].cCompanyId;
          this.EditedCompanyId = vcompanyid;
          //this.Addcomp = [] as any;
          this.Addcomp = [];
          for (var i = 0; i < data.length; i++) {
            var vLength = 0;
            if (this.Addcomp == null)
              vLength = 0;
            else
              vLength = this.Addcomp.length;
            var v1 = "CompanyName" + (i + 1);
            var v2 = "CompanyRole" + (i + 1);
            var v3 = "CompanyDate" + (i + 1);
            var v4 = "companyvar" + (vLength + 1);
            var vccompanyId = vData[i].cCompanyId;


            this.Addcomp.push({ CompanyName: v1, CompanyRole: v2, CompanyDate: v3, CompanyId: vccompanyId, companyvar: v4 });
            debugger;
          }
          setTimeout(() => {


            for (var j = 0; j < this.Addcomp.length; j++) {
              debugger;

              var v11 = this.Addcomp[j].CompanyName;
              var v12 = this.Addcomp[j].CompanyRole;
              var v13 = this.Addcomp[j].CompanyDate;


              var CompanyName = vData[j].cpysignedby;
              var CompanyRole = vData[j].cpysignedrole;
              var CompanyDate = vData[j].cpysigneddate;
              debugger;

              if (CompanyName != null) {
                ((document.getElementById(v11) as HTMLInputElement).value) = CompanyName;
              }
              debugger;
              if (CompanyRole != null) {
                ((document.getElementById(v12) as HTMLInputElement).value) = CompanyRole;
              }
              if (CompanyDate != null) {
                var vvcmpyDate = CompanyDate;
                CompanyDate = new Date(new Date(vvcmpyDate).setDate(new Date(vvcmpyDate).getDate() + 1)).toISOString().split('T')[0];
                ((document.getElementById(v13) as HTMLInputElement).value) = CompanyDate;
              }
            }

          }, 2000);
        }
        else {

        }
      });

    var value2 = this.http.get(environment.apiUrl + 'NDA/GetClentForEdit?contractID=' + vndaid).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData1 = data;
          debugger;
          var vclientid = vData1["0"].cclientId;
          this.EditedClientId = vclientid;
          //this.Adclient = [] as any;
          this.Adclient = [];
          for (var n = 0; n < data.length; n++) {
            var vLength = 0;
            if (this.Adclient == null)
              vLength = 0;
            else
              vLength = this.Adclient.length;
            var v1 = "ClientName" + (n + 1);
            var v2 = "ClientRole" + (n + 1);
            var v3 = "ClientDate" + (n + 1);
            var v4 = "clientvar" + (vLength + 1);
            var vcclientId = vData1[n].cclientId;


            this.Adclient.push({ ClientName: v1, ClientRole: v2, ClientDate: v3, ClientId: vcclientId, clientvar: v4 });
            debugger;
          }

          setTimeout(() => {


            for (var k = 0; k < this.Adclient.length; k++) {
              debugger;

              var v11 = this.Adclient[k].ClientName;
              var v12 = this.Adclient[k].ClientRole;
              var v13 = this.Adclient[k].ClientDate;


              var ClientName = vData1[k].clsignedby;
              var ClientRole = vData1[k].clsignedrole;
              var ClientDate = vData1[k].clsigneddate;
              debugger;

              if (ClientName != null) {
                ((document.getElementById(v11) as HTMLInputElement).value) = ClientName;
              }
              debugger;
              if (ClientRole != null) {
                ((document.getElementById(v12) as HTMLInputElement).value) = ClientRole;
              }
              if (ClientDate != null) {
                var vvClientDate = ClientDate;
                ClientDate = new Date(new Date(vvClientDate).setDate(new Date(vvClientDate).getDate() + 1)).toISOString().split('T')[0];
                ((document.getElementById(v13) as HTMLInputElement).value) = ClientDate;
              }
            }

          }, 2000);
        }
        else {

        }
      });
    this.updatedocid = [];
    this.selects = [];
    var value3 = this.http.get(environment.apiUrl + 'NDA/GetDocForEdit?contractID=' + vndaid).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData1 = data;
          debugger;
          for (var i = 0; i < vData1.length; i++) {
            this.EditedDoc = vData1[i];
            var vdocId = this.EditedDoc.cdocId;
            var vdocurl = this.EditedDoc.docUrl;
            var furl = vdocurl;
            this.isShownimage = false;
            this.isShowndoclist = false;
            var cvname = furl.split("/");
            var fname = cvname[6];
            this.selects.push({ docid: vdocId, filename: fname, fileURL: furl });
            this.updatedocid.push({ updocid: vdocId, upfileurl: furl });
            //var fdocid = this.updatedocid;                 
          }

        }
      });

  }


  Updatenda() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    var vndaname = this.onboardingid;
    var vclientid = this.contractsid;
    var vcontractnum = this.contractNum;
    var vService = this.cntService;
    var vValidfrom = this.Validfrom;
    var vValidTo = this.ValidTo;
    var vdescription = this.description;


    debugger;

    if (vndaname == undefined || vndaname == "" || vndaname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Customer Code.";
      return false;
    }

    if (vclientid == undefined || vclientid == "" || vclientid == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contract.";
      return false;
    }

    if (vcontractnum == undefined || vcontractnum == "" || vcontractnum == "0") {
      this.contractNum = "1";
    }

    if (vValidfrom == undefined || vValidfrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid From Date.";
      return false;
    }

    if (vValidTo == undefined || vValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid To Date.";
      return false;
    }
    if (vValidfrom > vValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should Greater then Valid From Date.";
      return false;
    }
    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = ""
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";


    if (this.Addcomp != null) {
      if (this.Addcomp.length != 0) {
        for (var i = this.Addcomp.length - 1; i >= 0; i--) {
          var v1 = this.Addcomp[i].CompanyName;
          var v2 = this.Addcomp[i].CompanyRole;
          var v3 = this.Addcomp[i].CompanyDate;
          debugger;
          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarCompanyName == undefined || vVarCompanyName == "" || vVarCompanyName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Company.";
            return false;
          }

          if (vVarCompanyRole == undefined || vVarCompanyRole == "" || vVarCompanyRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Role.";
            return false;
          }

          if (vVarCompanyDate == undefined || vVarCompanyDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Date.";
            return false;
          }

          if (vValidfrom >= vVarCompanyDate || vValidTo <= vVarCompanyDate) {
            this.isShownError = false;
            this.ErrorMsg = "Company Signed Date should between Valid From and Valid To Date .";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Company Details..";
      return false;
    }
    if (this.Adclient != null) {
      if (this.Adclient.length != 0) {
        for (var i = this.Adclient.length - 1; i >= 0; i--) {
          var v1 = this.Adclient[i].ClientName;
          var v2 = this.Adclient[i].ClientRole;
          var v3 = this.Adclient[i].ClientDate;
          debugger;
          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarClientName == undefined || vVarClientName == "" || vVarClientName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Client.";
            return false;
          }

          if (vVarClientRole == undefined || vVarClientRole == "" || vVarClientRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Role.";
            return false;
          }

          if (vVarClientDate == undefined || vVarClientDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Date.";
            return false;
          }

          if (vValidfrom >= vVarClientDate || vValidTo <= vVarClientDate) {
            this.isShownError = false;
            this.ErrorMsg = "Client Signed Date should between Valid From and Valid To Date .";
            return false;
          }

        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Client Details..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dndaname', this.onboardingid);
    params = params.append('dclientid', this.contractsid);
    params = params.append('dContractNumber', this.contractNum);
    params = params.append('dService', this.cntService);
    params = params.append('dValidfrom', this.Validfrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('iContracts', this.EditedNDAId);
    params = params.append('istatus', vStatus)

    var value = this.http.get(environment.apiUrl + 'NDA/UpdateNDA', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var NDAID = data;
        for (var i = this.Addcomp.length - 1; i >= 0; i--) {
          var v1 = this.Addcomp[i].CompanyName;
          var v2 = this.Addcomp[i].CompanyRole;
          var v3 = this.Addcomp[i].CompanyDate;

          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params1 = new HttpParams();
          params1 = params1.append('icompanyid', this.EditedCompanyId);
          params1 = params1.append('iNDAID', NDAID);
          params1 = params1.append('iCompanyName', vVarCompanyName);
          params1 = params1.append('irole', vVarCompanyRole);
          params1 = params1.append('iDate', vVarCompanyDate);
          var value = this.http.get(environment.apiUrl + 'NDA/UpdateNDACompany', { params: params1 }).toPromise().then((data))
        }
        for (var i = this.Adclient.length - 1; i >= 0; i--) {
          var v1 = this.Adclient[i].ClientName;
          var v2 = this.Adclient[i].ClientRole;
          var v3 = this.Adclient[i].ClientDate;

          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params2 = new HttpParams();
          params2 = params2.append('iclientid', this.EditedClientId);
          params2 = params2.append('siNDAID', NDAID);
          params2 = params2.append('sCompanyName', vVarClientName);
          params2 = params2.append('srole', vVarClientRole);
          params2 = params2.append('sDate', vVarClientDate);
          var value1 = this.http.get(environment.apiUrl + 'NDA/UpdateNDAClient', { params: params2 }).toPromise().then((data))
        }

        var spliturl = this.updatedocid;
        debugger;
        for (var i = 0; i < spliturl.length; i++) {
          var furl = spliturl[i];
          var vvuid = furl.updocid;
          var vvurl = furl.upfileurl;
          let params3 = new HttpParams();
          params3 = params3.append('nContractId', ContractId);
          params3 = params3.append('nfurl', vvurl);
          params3 = params3.append('idocumentId', vvuid);
          debugger;
          var value2 = this.http.get(environment.apiUrl + 'NDA/UpdateNDADoc', { params: params3 }).toPromise().then((data))
          debugger;
        }
        debugger;
        this.isShownSuccess = false;
        this.SuccessMsg = "NDA Updated."
        this.BindNdaGrid();
        this.BindNDAExport();
        var ContractId = data;
        this.NDAName = "";
        //this.onboardingid = "";
        var vcustomcode = this.sOnboardingId;
        this.onboardingid =vcustomcode;
        this.ContractNumber = "";
        this.cntService = "";
        this.Validfrom = "";
        this.ValidTo = "";
        this.CompanyName = "";
        this.CompanyRole = "";
        this.CompanyDate = "";
        this.ClientName = "";
        this.ClientRole = "";
        this.ClientDate = "";
        this.description = "";
        this.surl = "";
        this.isShowndoclist = true;
        this.isShownservice = true;
        this.isShownActive = true;
        this.isShownUpdateBtn = true;
        this.isShownSaveBtn = false;
        this.Addcomp = [];
        this.Addcomp.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
        this.Adclient = [];
        this.Adclient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
this.BindContractDDL();
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }

  BindNdaGrid() {
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'NDA/GetNDAForGrid',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindNDAExport() {
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'NDA/GetNdaForExport',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.NDAExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.NDAExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'NDA');

    /* save to file */
    XLSX.writeFile(wb, "NDA.xlsx");

  } 

  RemoveCompany(item: any) {
    debugger;
    this.NDACompanyRemove = item;

    if (this.Addcomp != null) {

      if (this.Addcomp.length != 0 && this.Addcomp.length != 1) {
        for (var i = this.Addcomp.length - 1; i >= 0; i--) {
          //vName: v1, vPrice: v2, vImage: v3
          var v1 = this.Addcomp[i].CompanyName;
          var vNme = this.NDACompanyRemove.CompanyName;

          if (v1 == vNme) {
            if (v1 == vNme) {
              Swal.fire({
                title: 'Are you sure?',
                text: 'You want to remove this Row!',

                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it'
              }).then((result) => {
                if (result.value) {
                  this.Addcomp.splice(i, 1);
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  // Swal.fire(
                  //   'Cancelled',
                  //   'Your Row is safe :)',
                  //   'error'
                  // )
                }
              })

            }
          }
        }
      }
      else {
        Swal.fire('', 'You Cannot Delete The Master Record.')
      }
    }
  }

  RemoveClient(item: any) {
    this.NDAClientRemove = item;

    if (this.Adclient != null) {

      if (this.Adclient.length != 0 && this.Adclient.length != 1) {
        for (var i = this.Adclient.length - 1; i >= 0; i--) {
          var v1 = this.Adclient[i].ClientName;
          var vNme = this.NDAClientRemove.ClientName;

          if (v1 == vNme) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You want to remove this Row!',

              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!',
              cancelButtonText: 'No, keep it'
            }).then((result) => {
              if (result.value) {
                this.Adclient.splice(i, 1);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal.fire(
                //   'Cancelled',
                //   'Your Row is safe :)',
                //   'error'
                // )
              }
            })


          }
        }
      }
      else {
        Swal.fire('', 'You Cannot Delete The Master Record.')
      }
    }


  }

  RemoveDocument(item: any,index) {

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to remove this File!',

      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.selects.splice(index,1);
        if(item.docid == undefined)
{
  let params = new HttpParams();
    params = params.append('lDocumentId', item.docid);
    var value = this.http.get(environment.apiUrl + 'NDA/DeleteNDADoc', { params: params }).toPromise().then(
      (data: any) => {
       
        var returnValue = data;
        return false;
      }).catch((data: any) => {
        
        var vDataError = JSON.stringify(data.error.text);
       
              var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Delete Failed, Please Try Again.";
          return false;
        }
        else if(vErrorMsg1 == "Success")
        {
          
          return false;
  
        }

  


  });
}

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
     
  

  }



}
